import { createStore } from "vuex";
import axios from "axios";

//
const store = createStore({
  state() {
    return {
      user: undefined,
      locations: [],
      currentTipSplitBreakdown: null,
      tipSplits: [
        // {
        //   createdAt: 1657997121162,
        //   startTime: "2022-06-26",
        //   endTime: "2022-06-26",
        //   source: {
        //     name: "Chris Kruse",
        //     userId: "4c288f94-62e1-4099-8780-edda603f3b6e",
        //     email: "krusecodes@gmail.com",
        //   },
        //   reportId: "1657997121162",
        //   status: "complete",
        // },
        // {
        //   createdAt: 1658000569938,
        //   startTime: "2022-06-27",
        //   endTime: "2022-06-27",
        //   source: {
        //     name: "Chris Kruse",
        //     userId: "4c288f94-62e1-4099-8780-edda603f3b6e",
        //     email: "krusecodes@gmail.com",
        //   },
        //   reportId: "1658000569938",
        //   status: "complete",
        // },
      ],
    };
  },
  mutations: {
    set(state, [variable, value]) {
      state[variable] = value;
    },
    toggle(state, variable) {
      state[variable] = !state[variable];
    },
    addTipSplitReport(state, report) {
      state.tipSplits.unshift(report);
    },
    updateTipSplitReport(state, [reportId, report]) {
      state.tipSplits.forEach((tipSplit, i) => {
        if (tipSplit.reportId == reportId) {
          state.tipSplits[i] = report;
        }
      });
    },
    setCurrentTipSplitBreakdown(state, breakdown) {
      state.currentTipSplitBreakdown = breakdown;
    },
  },
  actions: {
    async callAPI(context, body) {
      return await axios.post(process.env.VUE_APP_API_BASE_URL, body, {
        headers: {
          Authorization: context.state.user.signInUserSession.idToken.jwtToken,
        },
      });
    },
  },
});

//
export default store;
